import { INode, FeatureType, ICAMSKey, OrderDirection, IAPIResult} from '../Shared/Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities } from '../Shared/Utility/Utilities';
import * as events from '../Shared/Bus/Bus';
import * as AuthModel from '../Shared/Models/AuthModel';
import { Translations } from '../Shared/Models/StaticTranslations';

export class ConditionSurvey {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private treeView: any;
    private treeData: Array<INode> = [];
    private currentTask: ICAMSKey;
    private parentFeature: ICAMSKey;

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults
    // List of buttions in the action toolbar
    private actionBtns = {
        map: { btn: $('#conditionSurveyListZoomToMapSelectedBtn'), enable: false },
        addIssue: { btn: $('#conditionSurveyListAddIssueBtn'), enable: false },
        addFurniture: { btn: $('#conditionSurveyListAddFurnitureBtn'), enable: false },
        complete: { btn: $('#conditionSurveyListCompleteBtn'), enable: false },
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected authModel: AuthModel.IAuthModel) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;

        // Bind buttons
        $('#conditionSurveyListCloseBtn').on("click", function () {
            events.bus.publish(events.eventResetAllPanels());
            events.bus.publish(events.eventRemoveAllMapInteractions());
            events.bus.publish(events.eventResetAllButtons(true));

            events.bus.publish(events.eventOpenTasksViewPanel([self.currentTask, "show", null, true]));
        });

        self.actionBtns.map.btn.on("click", function () {
            self.treeView.treeview('checkAll', { silent: true });
            self.ZoomToAll();
            this.blur();
        });

        self.actionBtns.addIssue.btn.on("click", function () {
            $('#conditionSurveyListPanel').removeClass('show');
            events.bus.publish(events.eventZoomToWKTandHighlight([[self.parentFeature.wkt], true, true, self.parentFeature.featureType]));
            let parentData: ICAMSKey = { code: self.parentFeature.code, featureType: FeatureType.Route, wkt: self.parentFeature.wkt };
            events.bus.publish(events.eventNewMaintWizardStart([parentData, null, function (r) { if (r != null || r != false) { self.OpenConditionSurveyStartPanel(self.currentTask); }  }]));
        });

        self.actionBtns.addFurniture.btn.on("click", function () {
            $('#conditionSurveyListPanel').removeClass('show');
            events.bus.publish(events.eventZoomToWKTandHighlight([[self.parentFeature.wkt], true, true, self.parentFeature.featureType]));
            let parentData: ICAMSKey = { code: self.parentFeature.code, featureType: FeatureType.Route, wkt: self.parentFeature.wkt };
            events.bus.publish(events.eventNewInfraWizardStart([parentData, null, function (r) { if (r != null || r != false) { self.OpenConditionSurveyStartPanel(self.currentTask); } }]));
        });

        self.actionBtns.complete.btn.on("click", function () {
            events.bus.publish(events.eventZoomToWKTandHighlight([[self.parentFeature.wkt], true, true, self.parentFeature.featureType]));
            let parentData: ICAMSKey = { code: self.parentFeature.code, featureType: FeatureType.Route, wkt: self.parentFeature.wkt };

            if (self.parentFeature.featureType == FeatureType.Route) {
                self.completeRouteSurvey(self.parentFeature.code);

            } else {
                self.completeInfraSurvey(self.parentFeature.code, true);
            }
        });
        
        // Action btns
        self.actionBtns.map.btn.on("click", function () { self.ZoomToAll(); this.blur(); });

        // Bind events from ConditionSurveyController.TreeUtility
        $(document).on('addConditionSurveyRoute', function (e, eventInfo) { self.completeRouteSurvey(eventInfo); });
        $(document).on('addConditionSurveyInfra', function (e, eventInfo) { self.completeInfraSurvey(eventInfo,false); });

    }

    // ----------------------------------------------------------- //
    // OPEN PANEL
    public OpenConditionSurveyStartPanel = (data: ICAMSKey): void => {
        const self = this;

        self.currentTask = data;
        self.parentFeature = { code: data.parentCode, featureType: data.parentFeatureType };

        this.resetPage();
        $('#conditionSurveyListPanel').addClass('show');
        events.bus.publish(events.eventRemoveAllMapInteractions());

        if (data.parentFeatureType == FeatureType.Route) self.actionBtns.addFurniture.btn.parent().show();
        else self.actionBtns.addFurniture.btn.parent().hide();

        // Get data
        self.GetTreeData();
    }

    // ----------------------------------------------------------- //
    // GET DATA FROM SERVER
    private GetTreeData = (): void => {
        const self = this;

        var url = window.G_SITEFOLDERNAME + "/ConditionSurvey/GetConditionSurveyTreeData";
        let query = { entityID: self.parentFeature.code, featureType: self.parentFeature.featureType };

        Utilities.BlockUI($('#conditionSurveyListPanel'));
        $.post(url, query,
            function (result: IAPIResult) {
                Utilities.UnBlockUI($('#conditionSurveyListPanel'));
                try {
                    if (result.success == true) {
                        self.DeleteAllNodes();
                      
                        var data = result.data.nodes as Array<INode>;
                        self.addData_to_treeData(data);
                        self.createTree(self.treeData, false);
                        self.ZoomToAll();

                        // Also copy the WKT for the first feature
                        if (data && data.length>0 && data[0].nodes && data[0].nodes.length>0)
                            self.parentFeature.wkt = data[0].nodes[0].wkt;
                    }
                    else {
                        toastr.error('Failed to get data!')
                    }
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            }
        ).fail(function (xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
        });
    }

    // ----------------------------------------------------------- //
    // CREATE/ADD TREE
    private createTree = (inData: Array<INode>, colapseAll: boolean): void => {
        const self = this;

        var tree: any = $('#conditionSurveyListTreeResults');
        self.treeView = tree.treeview({
            data: inData,
            showCheckbox: false,
            multiSelect: false,
            onNodeSelected: function (event, node) {
                // DO not show the officer map edit forms if the user is not authorized
                if (self.authModel.policies.find(p => p == AuthModel.CAMSOfficerMap) == null) return;
     
                // Only open the edit form if this is NOT the root node
                let data: ICAMSKey = { code: node.href, featureType: node.featureType };
                if (node.doNotOpenEditForm != true) {
                    if (inData[0].href != node.href) {
                        events.bus.publish(events.eventOpenEditPanel(data));
                    } else self.ZoomToAll();
                }
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = null; // Remove this temp settings

                self.treeView.treeview('uncheckAll', [{ silent: true }]);
   
            },
            onNodeUnselected: function (event, node: INode) {
              
            },
            onNodeChecked: function (event, node) {
                self.treeView.treeview('unselectAll', [{ silent: true }]);
        
            },
            onNodeUnchecked: function (event, node) {
               
            },
            onMapBtnClicked: function (event, node)
            {
                // Get the correct node instance from the tree and then fire the nodeSelected event
                var nodeA = self.treeView.treeview('getNode', node.nodeId);
                nodeA.doNotOpenEditForm = true; // temp set this to stop the edit form being opened
                self.treeView.treeview('selectNode', [nodeA, { silent: false }]);
                // ****************************************************************************** //

                if (node.wkt) {
                    // If it is the root node, zoom to all. Otherwise zoom to the main root and the item selected
                    if (inData[0].href == node.href) {
                        self.ZoomToAll();
                    }
                    else {
                        events.bus.publish(events.eventZoomToWKTandHighlight([[inData[0].wkt, node.wkt], true, true, node.featureType]));
                    }
                }
                else {
                    toastr.info('The record has no associated map feature')
                }
            }
        });

        // Create the tree header
        self.createTreeHeader();

        if (colapseAll == true) {
            self.treeView.treeview('collapseAll');
        }
    }

    private addData_to_treeData = (input: Array<INode>): void => {
        const self = this;

        switch (self.parentFeature.featureType) {
            case FeatureType.Route:
                add_noParentNode(FeatureType.RouteParent); count(FeatureType.RouteParent);
                break;
            case FeatureType.Maint:
                add_noParentNode(FeatureType.MaintParent); count(FeatureType.MaintParent);
                break;
            case FeatureType.Infra:
                add_noParentNode(FeatureType.InfraParent); count(FeatureType.InfraParent);
                break;
        }

        function add_noParentNode(featureType: FeatureType) {
            if (self.treeData == null) { self.treeData = []; }
            var inNode = input.find(f => f.featureType == featureType);
            if (inNode != null && inNode.nodes != null) {
                inNode.nodes.forEach(i => {
                    let index = self.treeData.findIndex(f => f.href == i.href);
                    if (index < 0) {
                        self.treeData.push(i); // Only add nodes if they are not already in the tree
                    }
                    else {
                        self.treeData[index] = i;
                    }
                });
            }
        }

        function count(featureType: FeatureType) {
            let outNode = self.treeData.find(f => f.featureType == featureType);
            if (outNode != null) {
                if (outNode.nodes == null) {
                    outNode.count = 0;
                }
                else {
                    outNode.count = outNode.nodes.length;
                }
            }
        }
    }


    private DeleteAllNodes = (): void => {
        this.treeData = [];
        this.createTree(this.treeData, true);
    }

    private ZoomToAll = (): void => {
        const self = this;

        var wktArr = [];

        getWKT(self.treeData);
        function getWKT(data: INode[]) {
            data.forEach(n => {
                if (n.wkt != null) {
                    wktArr.push(n.wkt);
                }
                if (n.nodes && n.nodes.length > 0) {
                    getWKT(n.nodes);
                }
            });
        }
        events.bus.publish(events.eventZoomToWKTandHighlight([wktArr, true, true, null]));
    }

    // ----------------------------------------------------------- //
    // TREE HEADERS
    private createTreeHeader = (): void => {
        const self = this;
        var lang = window.isSiteInWelsh() == true ? 1 : 0;

        // Add the header to issues only
        var colDef;
        if (self.parentFeature.featureType == FeatureType.Maint) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: null, size: 2 },
                { label: Translations.Lang.Logged[lang], value: null, size: 2 },
                { label: Translations.Lang.Type[lang], value: null, size: 4 },
                { label: Translations.Lang.Priority[lang], value: null, size: 2 },
                { label: Translations.Lang.Status[lang], value: null, size: 2 }
            ];
            
        }
        else if (self.parentFeature.featureType == FeatureType.Infra) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: null, size: 2 },
                { label: Translations.Lang.Type[lang], value: null, size: 6 },
                { label: Translations.Lang.LastCondition[lang], value: null, size: 4 }
            ];
        }
        else if (self.parentFeature.featureType == FeatureType.Route) {
            colDef = [
                { label: Translations.Lang.Code[lang], value: null, size: 2 },
                { label: Translations.Lang.Status[lang], value: null, size: 2 },
                { label: Translations.Lang.LegalType[lang], value: null, size: 2 },
                { label: Translations.Lang.Parish[lang], value: null, size: 2 },
                { label: Translations.Lang.LastCondition[lang], value: null, size: 4 }
            ];
        }
        

        // Create the header
        self.treeView.treeview('addHeader', {
            cols: colDef,
            callback: function (order, dir) {
                self.GetTreeData();
            }
        });

    }

    // ----------------------------------------------------------- //
    // MISC
    private resetPage = (): void => {
        // Reset the page
        
        var tree: any = $('#conditionSurveyListTreeResults');
        this.treeData = [];
        this.treeView = tree.treeview();
    }

    public GetRecordSelectRecords = (callback: Function): void => {
        var result = [];
        if (this.treeView != undefined) result = this.treeView.treeview('getChecked')
        callback(result);
    }

    public reRunLastInfoRequest = (): void => {
        const self = this;
        self.GetTreeData();
    }

    private completeRouteSurvey = (routeCode: string): void => {
        const self = this;
        events.bus.publish(events.eventOpenRouteConditionCreatePanel([{ code: routeCode, featureType: FeatureType.Route }, function (result) {
            if (result == true) {
                self.GetTreeData();
                events.bus.publish(events.eventOpenTasksCompletePanel([self.currentTask, false, function (result) {
                    events.bus.publish(events.eventResetAllPanels());
                    events.bus.publish(events.eventRemoveAllMapInteractions());
                    events.bus.publish(events.eventResetAllButtons(true));
                    events.bus.publish(events.eventOpenMyTasksRecordListPanel());
                }]));
            }
        }]));
    }

    private completeInfraSurvey = (infraCode: string, completeTask: Boolean): void => {
        const self = this;
  
        events.bus.publish(events.eventOpenInfraConditionPanel([{ code: infraCode, featureType: FeatureType.Infra }, null, function (result, camsKey, newIssueFlag) {
            if (newIssueFlag == true) {
                events.bus.publish(events.eventOpenMaintCreatePanel([camsKey, complete]));
            }
            else complete();

            function complete() { 
                self.GetTreeData();
                if (result == true && completeTask == true) {
                    events.bus.publish(events.eventOpenTasksCompletePanel([self.currentTask, false, function (result) {
                        events.bus.publish(events.eventResetAllPanels());
                        events.bus.publish(events.eventRemoveAllMapInteractions());
                        events.bus.publish(events.eventResetAllButtons(true));
                        events.bus.publish(events.eventOpenMyTasksRecordListPanel());


                    }]));
                }
            }
        }]));
    }
}




